import { render } from "./Fechar.vue?vue&type=template&id=4decc4f0"
import script from "./Fechar.vue?vue&type=script&lang=js"
export * from "./Fechar.vue?vue&type=script&lang=js"
script.render = render

export default script